import React from 'react';
import { ConnectionLineComponentProps, Node } from '@xyflow/react';

export const AnimatedConnectionLine: React.FC<ConnectionLineComponentProps<Node>> = ({
  fromX,
  fromY,
  toX,
  toY,
  connectionLineStyle = {},
}) => {
  const strokeColor = connectionLineStyle.stroke || 'var(--color-greyscale-200)';
  const strokeWidth =
    typeof connectionLineStyle.strokeWidth === 'number' ? connectionLineStyle.strokeWidth : 2;

  // recreate bezier curve for the connection line
  const distance = Math.sqrt(Math.pow(toX - fromX, 2) + Math.pow(toY - fromY, 2));
  const curveIntensity = Math.min(distance * 0.3, 80);
  const controlPoint1X = fromX + curveIntensity;
  const controlPoint1Y = fromY;
  const controlPoint2X = toX - curveIntensity;
  const controlPoint2Y = toY;

  const edgePath = `M ${fromX} ${fromY} C ${controlPoint1X} ${controlPoint1Y} ${controlPoint2X} ${controlPoint2Y} ${toX} ${toY}`;

  return (
    <g>
      <path
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        d={edgePath}
        className="animated"
      />
    </g>
  );
};

export default AnimatedConnectionLine;
